import React, { Component, PureComponent } from 'react'
import {
    Paper,
    Toolbar,
    IconButton,
    Typography,
    withStyles,
  } from '@material-ui/core';
import ChevronBackIcon from '../svgs/ChevronBackIcon';
import { withRouter } from 'react-router-dom';
import {MILITARY_PROPS} from '../../../../shared/constants/RadioProps';
import { hasOptions, isNullOrEmpty } from '../../../../shared/utils/Helpers';
import { rwbApi } from '../../../../shared/apis/api'; 
import { projectConfig } from '../../../../shared/project-info/projectConfig';
import moment from 'moment';
import styles from '../../../../social-stack-web/src/components/registration/Registration.module.css'
import CustomButton from '../CustomButton';

import {
  primaryOptions,
  subOptions,
  subOptionTitle,
} from '../../../../shared/project-info/serviceInfo';
import { logUpdateMilitaryService } from '../../../../shared/models/Analytics';
import { InfoForm } from '../../../../shared/project-info/ProfileEditInfoForm';
import { GENERIC_ERROR } from '../../../../shared/constants/ErrorMessages';

const {
  status_radio_props,
  branch_radio_props,
  zone_radio_props,
  deployment_radio_props,
  disability_radio_props,
} = MILITARY_PROPS;


  const useStyles = {
    root: {
      flexGrow: 1,
    },
    menuButton: {
      color: 'var(--white)',
    },
    title: {
      color: 'var(--white)',
      textTransform: 'capitalize',
      fontFamily: 'OpenSans-Bold',
      textAlign: 'center',
      // title should always center, regardless of length of siblings
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
    },
    toolbar: {
      position: 'relative',
      justifyContent: 'space-between',
      backgroundColor: 'var(--primary)',
    },
    button: {
      color: 'white',
      textTransform: 'capitalize',
    },
    save: {
      color: 'var(--white)',
      textTransform: 'capitalize',
      fontWeight: 'bold',
    },
  };
export class ProfileExtraInfoUpdate extends PureComponent {
  constructor(props) {
    super(props);

    const {navigation,location} = this.props;

    const value = location.state.value;
    
    if (value === null)
      throw new Error('ProfileExtraInfoUpdate must be given navigation value.');
    const {
      military_status,
      military_family_member,
      military_branch,
      industry,
      years_in_industry,
      military_specialty,
      military_rank,
      military_ets,
      has_disability,
      combat_zone,
      combat_deployment_operations,
      service_info,
      extra_info
    } = value;
    const etsDate = moment(military_ets);
    const ets_date_valid = etsDate.isValid();

    this.state = {
      military_status: service_info?.status,
      military_family_member,
      military_branch: service_info?.service_type,

      etsd_month: ets_date_valid ? etsDate.format('MMMM') : '',
      etsd_day: ets_date_valid ? etsDate.format('DD') : '',
      etsd_year: ets_date_valid ? etsDate.format('YYYY') : '',
      military_specialty,
      military_rank,
      has_disability: has_disability ? true : false,
      combat_zone,
      combat_deployment_operations,
      service_info,
      industry: '',
      years: '',
      extra_info,

      military_status_error: '',
      military_branch_error: '',
      etsd_error: '',
      military_specialty_error: '',
      military_rank_error: '',
      has_disability_error: '',
      combat_deployment_operations_error: '',
      industry_error: '',
      years_error: '',

      specialtyVisible: false,
      rankVisible: false,
      monthVisible: false,
      dayVisible: false,
      yearVisible: false,

      isLoading: false,
      needsToSave: false,
    };

    // this.backPressed = this.backPressed.bind(this);
    // this.savePressed = this.savePressed.bind(this);
    // this.handleBackPress = this.handleBackPress.bind(this);
    // this.onMonthSelect = this.onMonthSelect.bind(this);
    // this.onDaySelect = this.onDaySelect.bind(this);
    // this.onYearSelect = this.onYearSelect.bind(this);
  }

  clearErrorWarnings = () => {
    this.setState({
      military_status_error: '',
      military_branch_error: '',
      etsd_error: '',
      military_specialty_error: '',
      military_rank_error: '',
      has_disability_error: '',
      combat_deployment_operations_error: '',
      industry_error: '',
      years_error: '',
    });
  };

  validateProfile = () => {
    const {
      military_status,
      military_branch,
      military_specialty,
      military_rank,
      combat_zone,
      combat_deployment_operations,
      has_disability,
      etsd_month,
      etsd_day,
      etsd_year,
    } = this.state;
    const REQUIRED_FIELD = 'THIS FIELD IS REQUIRED';
    const INVALID_YEAR = 'INVALID NUMBER OF YEARS';
    const INVALID_DATE = 'INVALID DATE';
    let hasError = false;

    if (this.state.extra_info?.industry) {
      const {
        industry,
        years
      } = this.state;
  
      if (isNullOrEmpty(industry)) {
        this.setState({industry_error: REQUIRED_FIELD});
        hasError = true;
      }
      /*
      Years is not currently used, but it might be something we add back in
      hence the commented code.
      if (!years) {
        this.setState({years_error: REQUIRED_FIELD});
        hasError = true;
      }
      if (years > 100) {
        this.setState({years_error: INVALID_YEAR});
        hasError = true;
      }*/
      if (hasError) return;
      let {history,location} = this.props;
      let value = location.state.value
      
      value = Object.assign(
        value,
        {
          extra_info:{
            industry: industry,
            years_in_industry: years
          }
        }
      ); 
    }

    if (this.state.service_info?.status) {
      let etsdDate = '';
      if (military_status === null) {
        this.setState({military_status_error: REQUIRED_FIELD});
        hasError = true;
      }
  
      if (hasOptions(military_status, primaryOptions)) {
        // server returns n\a and empty strings, so being extra safe
        if (
          military_branch === null ||
          military_branch === '' ||
          military_branch === 'n/a'
        ) {
          this.setState({military_branch_error: REQUIRED_FIELD});
          hasError = true;
        }
        // if (military_specialty === null || military_specialty === '') {
        //   this.setState({ military_specialty_error: REQUIRED_FIELD });
        //   hasError = true;
        // }
        // if (military_rank === null || military_rank === '') {
        //   this.setState({military_rank_error: REQUIRED_FIELD});
        //   hasError = true;
        // }
        if (
          combat_zone === true &&
          (combat_deployment_operations === null ||
            combat_deployment_operations === '' ||
            combat_deployment_operations === 'n/a')
        ) {
          this.setState({combat_deployment_operations_error: REQUIRED_FIELD});
          hasError = true;
        }
        if (has_disability === null) {
          this.setState({has_disability_error: REQUIRED_FIELD});
          hasError = true;
        }
        // if (military_status === MILITARY_STATUSES.veteran) {
        //   if (etsd_month || etsd_day || etsd_year) {
        //     etsdDate = moment(
        //       `${etsd_month} ${etsd_day} ${etsd_year}`,
        //       'MMMM DD YYYY',
        //     );
        //     if (!etsdDate.isValid()) {
        //       this.setState({etsd_error: INVALID_DATE});
        //       hasError = true;
        //     }
        //   } else {
        //     this.setState({etsd_error: INVALID_DATE});
        //     hasError = true;
        //   }
        // }
      }
    }

    return !hasError;
  };

  savePressed = () => {
    this.clearErrorWarnings();
    if (this.validateProfile()) {
      this.makePayload();
    }
  };

  makePayload() {
    const {
      military_status,
      military_family_member,
      military_branch,
      combat_zone,
      combat_deployment_operations,
      has_disability,
      etsd_month,
      etsd_day,
      etsd_year,
      military_specialty,
      military_rank,
      industry,
      years,
      extra_info
    } = this.state;
    const etsdDate = moment(
      `${etsd_month} ${etsd_day} ${etsd_year}`,
      'MMMM DD YYYY',
    );
    let payload;
    if (this.state.extra_info?.industry) {
      payload = Object.assign(
        !hasOptions(industry, years)
      ? {
          extra_info: {
            industry: industry,
            years_in_industry: years,
          },
        }
      : {
        extra_info: {
          industry: null,
          years_in_industry: null,
        },
        },
      )
    }
    if (this.state.service_info?.status) {
      payload = Object.assign(
        {
          combat_zone:
            combat_zone && hasOptions(military_status, primaryOptions)
              ? combat_zone
              : null,
          military_specialty:
            military_specialty && hasOptions(military_status, primaryOptions)
              ? military_specialty
              : null,
          military_rank:
            military_rank && hasOptions(military_status, primaryOptions)
              ? military_rank
              : null,
        },
        !hasOptions(military_status, primaryOptions)
          ? {
              service_info: {
                status: military_status,
                culturally_and_linguistically_diverse: has_disability,
              },
            }
          : {
              service_info: {
                status: military_status,
                service_type: military_branch,
                culturally_and_linguistically_diverse: has_disability,
              },
            },
        // hasOptions(military_status, primaryOptions)
        //   ? {
        //       military_ets: etsdDate.toISOString().slice(0, 10),
        //     }
        //   : {},
      ); 
    }
    this.updateUser(payload);
  }

  updateUser(payload) {
    const { history ,location} = this.props
    
    this.setState({isLoading: true});

    let data = JSON.stringify(payload);

    return rwbApi
      .putUser(data)
      .then((response) => {
        logUpdateMilitaryService();
        this.setState({
          isLoading: false,
        });

        // this.props.navigation.state.params.getUpdatedProfile();

         history.goBack()
        //  location.state.updateProfile()
        // NavigationService.back();
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          isLoading: false,
        });
        // errorAlert("GENERIC_ERROR");
        alert(GENERIC_ERROR)
      });
  }

  onSpecialtySelect = (specialty) => {
    if (specialty) {
      this.setState({military_specialty: specialty});
    }
    this.setState({specialtyVisible: false, military_specialty_error: false});
  };

  onRankSelect = (rank) => {
    if (rank) {
      this.setState({military_rank: rank});
    }
    this.setState({rankVisible: false, military_rank_error: false});
  };

  onMonthSelect(month) {
    if (month) this.setState({etsd_month: month, monthVisible: false});
    else this.setState({monthVisible: false});
  }

  onDaySelect(day) {
    if (day) this.setState({etsd_day: day, dayVisible: false});
    else this.setState({dayVisible: false});
  }

  onYearSelect(year) {
    if (year) this.setState({etsd_year: year, yearVisible: false});
    else this.setState({yearVisible: false});
  }

  setServiceCheck = (value) => {
    this.setState({
      has_disability: value,
      has_disability_error: '',
    });
  };


  render() {
   
    const {navigation} = this.props;
    const {classes, history} = this.props;
    
  const {
      isLoading,

      military_status,
      military_family_member,
      military_branch,
      industry,
      years_in_industry,
      military_specialty,
      military_rank,
      has_disability,
      combat_zone,
      combat_deployment_operations,
      etsd_month,
      etsd_day,
      etsd_year,
      service_info,
      extra_info,

      military_status_error,
      military_branch_error,
      military_specialty_error,
      military_rank_error,
      has_disability_error,
      combat_deployment_operations_error,
      etsd_error,
    } = this.state;
    let data = {}
    if (extra_info?.industry) {
      data = 
      {
        extra_info: extra_info,
        industry_error: this.state.industry_error,
        years_error: this.state.years_error,
        OnchangeIndustry: (text) => {
          this.setState({industry: text});
        },
        OnchangeYears: (text) => {
          this.setState({years: parseInt(text)});
        }
      }
    }
    if (service_info?.status) {
      data = 
      {
        service_info: service_info,
        military_status: military_status,
        military_branch: military_branch,
        combat_zone: combat_zone,
        military_status_error: military_status_error,
        military_branch_error: military_branch_error,
        has_disability_error: has_disability_error,
        setServiceCheck: this.setServiceCheck,
        onPressStatus: (value) => {
            this.setState({
                military_status: value,
                military_status_error: '',
                needsToSave: true,
            });
        },
        onPressServiceType: (value) => {
            this.setState({
                military_branch: value,
                military_branch_error: '',
                military_specialty: '',
                military_rank: '',
                needsToSave: true,
            });
        }
      }
    }

    return (
      
      <div>

<Paper className={classes.root}>
          <Toolbar className={classes.toolbar}>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              onClick={() => history.goBack()}>
              <ChevronBackIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {projectConfig.profileInfoTitle}
            </Typography>
            <IconButton
              edge="end"
              className={classes.menuButton}
              color="inherit"
              onClick={() => this.savePressed()}>
              <Typography variant="h6" className={classes.save}>
                Save
              </Typography>
            </IconButton>
          </Toolbar>
        </Paper>

<InfoForm data={data}/>  
<div style={{
  maxWidth: 'calc(100% - 80px)',
  margin: '15px auto',
  display: 'block'
}}>
<CustomButton
        onClick={()=>this.savePressed()}
        label={'Save'}
        buttonStyle={'primary'}
    />
       </div>
       </div>
    )
  }
}
export default withRouter(withStyles(useStyles)(ProfileExtraInfoUpdate));
